import { render, staticRenderFns } from "./leave.vue?vue&type=template&id=6121f76c&scoped=true&"
import script from "./leave.vue?vue&type=script&lang=js&"
export * from "./leave.vue?vue&type=script&lang=js&"
import style0 from "./leave.vue?vue&type=style&index=0&id=6121f76c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121f76c",
  null
  
)

export default component.exports